import { useEffect, useMemo, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  fetchRefundMessage, fetchTotalData, fetchAdminDetail, fetchReceiptAuthUrl, fetchCommentMessage,
  fetchReviewMessage, fetchAfterSaleMessage, fetchDeviceMessage
} from '../../api'
import { set } from '../../utils/storage'
import { cacheKeys } from '../../utils/constant'
import { Card, Grid, Divider } from 'antd-mobile';
import { icons } from '../../assets/icons';
import { format } from '../../utils/price'
import { useLocation, useNavigationType } from 'react-router-dom';

// 定义卡片refs的类型
export type CardRefs = {
  [key: string]: HTMLElement | null;
};

// 定义路由状态类型
export interface RouteState {
  fromHome?: boolean;
  scrollTo?: string;
  fromDetail?: boolean;
}

// 定义路由状态类型
export interface RouteState {
  fromHome?: boolean;
  scrollTo?: string;
  fromDetail?: boolean;
}


export default function Nav() {
  const navigate = useNavigate()
  const [refundMsg, setRefundMsg] = useState(0)
  const [commentMsg, setCommentMsg] = useState(0)
  const [aftersaleMsg, setAftersaleMsg] = useState(0)
  const [reviewMsg, setReviewMsg] = useState(0)
  const [deviceMsg, setDeviceMsg] = useState(0)
  const [isAdmin, setIsAdmin] = useState(0)
  const [isProperty, setIsProperty] = useState(0)
  const [roleType, setRoleType] = useState(0)
  const [isLocation, setIsLocation] = useState(0)
  const [analysis, setAnalysis] = useState({
    incomeToday: 0,
    chargeToday: 0,
    receiptToday: 0,
    totalNum: 0,
    useNum: 0,
    idleNum: 0,
    offlineNum: 0,
    faultCount: 0,
  });
  const [isRefresh, setIsRefresh] = useState(false);

  const location = useLocation();
  const cardRefs = useRef<CardRefs>({});

  // 使用useMemo稳定ref回调
  const registerCardRef = useMemo(() => {
    return (id: string) => (el: HTMLElement | null) => {
      if (el) {
        cardRefs.current[id] = el;
      } else {
        delete cardRefs.current[id];
      }
    };
  }, []);

  const navigationType = useNavigationType(); // POP/PUSH/REPLACE

  useEffect(() => {
    if (navigationType === 'POP') {
      const navEntries = performance.getEntriesByType('navigation');
      const navEntry = navEntries[0] as PerformanceNavigationTiming | undefined;

      setIsRefresh(
        navEntry?.type === 'reload' ||
        (performance.navigation?.type === 1) // 兼容旧浏览器
      );
    }
  }, [navigationType]);

  useEffect(() => {
    fetchAdminDetail({}).then(res => {
      const adminType = Number(res.data.type)
      setRoleType(adminType)
      setIsLocation(Number(res.data.is_location))
      if (adminType === 1 || adminType === 3) {
        setIsAdmin(1)
      } else if (adminType === 4) {
        setIsProperty(1)
        // 物业：进入洗车对账展示页（只读、无顶栏返回）
        navigate('/free-park-list-view')
      }
      set(cacheKeys.isSuper, `${res.data.is_super}`, new Date().getTime() + 1 * 60 * 60 * 24)
    })
    fetchTotalData().then(res => {
      setAnalysis(res.data)
    })
    fetchRefundMessage().then(res => {
      setRefundMsg(res.data.num)
    })

    fetchCommentMessage().then(res => {
      setCommentMsg(res.data.num)
    })

    fetchAfterSaleMessage().then(res => {
      setAftersaleMsg(res.data.num)
    })

    fetchReviewMessage().then(res => {
      setReviewMsg(res.data.num)
    })

    fetchDeviceMessage().then(res => {
      setDeviceMsg(res.data.num)
    })
  }, [])

  useEffect(() => {
    const { scrollTo } = (location.state || {}) as { scrollTo?: string };
    if (!scrollTo) return;

    if (!location.state?.fromDetail || isRefresh) return;

    // 调整后的重试策略（首次延迟更长）
    let retryCount = 0;
    const tryScroll = () => {
      const el = cardRefs.current[scrollTo];
      console.log("滚动到元素位置", scrollTo)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (retryCount < 2) { // 最多重试2次（共3次）
        retryCount++;
        setTimeout(tryScroll, retryCount === 1 ? 150 : 100); // 首次150ms，后续100ms
      }
    };

    // 首次尝试延迟200ms（给DOM更多时间准备）
    const timer = setTimeout(tryScroll, 200);
    return () => clearTimeout(timer);
  }, [location.state, isRefresh]);

  // 跳转美团授权页
  function redirectAuthUrl() {
    fetchReceiptAuthUrl().then(res => {
      if (res?.data?.auth_url) {
        window.location.href = res.data.auth_url
      }
    })
  }

  return (
    <div>
      {isProperty !== 1 && (
        <Card className='custom-card'>
          <div style={{ textAlign: 'center' }}>
            <div className="fs-32 fw-bold" style={{
              background: 'linear-gradient(to bottom, #FFA42D, #FF6B00)', // 渐变色从上到下
              WebkitBackgroundClip: 'text',           // ✅ 兼容 iOS Safari
              WebkitTextFillColor: 'transparent',     // ✅ 让文字透明显示背景
              backgroundClip: 'text', // 让背景渐变应用到文字
              color: 'transparent', // 文字颜色设置为透明
            }}><span className="fs-20">¥</span> {format(analysis.incomeToday)}</div>
            <div className="fs-14 fc-gray">今日总收益</div>
          </div>
          <Divider />
          <Grid columns={2} className="vertical-divider">
            <div style={{ textAlign: 'center' }}>
              <div className="fs-20 fc-black"><span className="fs-14">¥</span> {format(analysis.chargeToday)}</div>
              <div className="fs-14 fc-gray">充值</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="fs-20 fc-black"><span className="fs-14">¥</span> {format(analysis.receiptToday)}</div>
              <div className="fs-14 fc-gray">核销</div>
            </div>
          </Grid>
        </Card>
      )
      }

      {isProperty !== 1 && (
        <Card title="设备状态" extra={
          <span className="fs-14 fc-gray">
            全部设备：
            <span className="fc-black fw-500">{analysis.totalNum}</span>台
          </span>
        } className="mt-16 custom-card" headerStyle={{ paddingLeft: 20, paddingRight: 20 }}>
          <Grid columns={4}>
            <div style={{ textAlign: 'center' }}>
              <div className="fs-18 mt-5 fc-green">{analysis.useNum}</div>
              <div className='mt-5'>使用中</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="fs-18 mt-5 fc-red">{analysis.faultCount}</div>
              <div className='mt-5'>故障</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="fs-18 mt-5 fc-black">{analysis.idleNum}</div>
              <div className='mt-5'>空闲</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="fs-18 mt-5 fc-orange">{analysis.offlineNum}</div>
              <div className='mt-5'>离线</div>
            </div>
          </Grid>
        </Card>
      )
      }

      {
        isAdmin === 1 ? (
          <Card title="运营管理" className="mt-16 no-divider custom-card" headerStyle={{ paddingLeft: 20 }}>
            <Grid columns={4} gap={26}>
              <div ref={registerCardRef('operationManagement')} className="flex-center" onClick={() => {
                navigate('/data-list', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.coreData} alt="核心数据" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/transaction', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.monthData} alt="月度数据" className="icon-image-style" />
              </div>
              <div className="flex-center" style={{ position: 'relative' }} onClick={() => {
                navigate('/comment', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                {commentMsg > 0 ? (
                  <div
                    className="flex-center fs-14"
                    style={{
                      position: 'absolute',
                      right: 15,   // 调整红点位置，确保它在图标的右上角
                      top: -6,     // 调整红点位置
                      height: 16,  // 红点高度
                      width: 16,   // 红点宽度
                      borderRadius: '50%',
                      backgroundColor: 'red',
                      color: '#fff',
                      fontSize: '10px', // 红点内部字体调整为适当大小
                      lineHeight: '16px',  // 使数字垂直居中
                    }}
                  >
                    {commentMsg}
                  </div>
                ) : (
                  <></>
                )}
                <img src={icons.reviewCoupon} alt="好评领券" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/shop-package', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.washPackage} alt="洗车套餐" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/profit', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }} >
                <img src={icons.storeRevenue} alt="门店营收" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/group-mapping', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.groupMap} alt="团购映射" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/shop-recharge', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.rechargePackage} alt="充值套餐" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/banner', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.advertisingSetting} alt="广告设置" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/activity', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.CrazyWashDay} alt="疯狂洗车日" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/wash-question', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                window.scrollTo(0, 0);
              }}>
                <img src={icons.WashProblem} alt="洗车有问题" className="icon-wash-problem-style" />
              </div>
            </Grid>
          </Card>) : (
          <Card title="门店数据" className="mt-16 no-divider custom-card" headerStyle={{ paddingLeft: 20 }}>
            <Grid columns={4} gap={26}>
              <div className="flex-center" onClick={() => {
                navigate('/data-list', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.coreData} alt="核心数据" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/transaction', {
                  state: {
                    fromHome: true,
                    scrollTo: 'operationManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.monthData} alt="交易数据" className="icon-image-style" />
              </div>
            </Grid>
          </Card>
        )
      }

      {
        isAdmin === 1 && (
          <Card title="交易管理" className="mt-16 no-divider custom-card" headerStyle={{ paddingLeft: 20 }}>
            <Grid columns={4} gap={16}>
              <div ref={registerCardRef('transactionManagement')} className="flex-center" onClick={() => {
                navigate('/orders', {
                  state: {
                    fromHome: true,
                    scrollTo: 'transactionManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.OrderRecord} alt="订单记录" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/recharge', {
                  state: {
                    fromHome: true,
                    scrollTo: 'transactionManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.RechargeRecord} alt="充值记录" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/receipt-list', {
                  state: {
                    fromHome: true,
                    scrollTo: 'transactionManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.VerificationRecord} alt="核销记录" className="icon-image-style" />
              </div>
              <div className="flex-center" style={{ position: 'relative' }} onClick={() => {
                navigate('/order-aftersale', {
                  state: {
                    fromHome: true,
                    scrollTo: 'transactionManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                {aftersaleMsg > 0 ? (
                  <div
                    className="flex-center fs-14"
                    style={{
                      position: 'absolute',
                      right: 20,   // 调整红点位置，确保它在图标的右上角
                      top: -2,     // 调整红点位置
                      height: 16,  // 红点高度
                      width: 16,   // 红点宽度
                      borderRadius: '50%',
                      backgroundColor: 'red',
                      color: '#fff',
                      fontSize: '10px', // 红点内部字体调整为适当大小
                      lineHeight: '16px',  // 使数字垂直居中
                    }}
                  >
                    {aftersaleMsg}
                  </div>
                ) : (
                  <></>
                )}
                <img src={icons.AfterSalesOrder} alt="售后订单" className="icon-image-style" />
              </div>
              <div className="flex-center" style={{ position: 'relative' }} onClick={() => {
                navigate('/refund', {
                  state: {
                    fromHome: true,
                    scrollTo: 'transactionManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                {refundMsg > 0 ? (
                  <div
                    className="flex-center fs-14"
                    style={{
                      position: 'absolute',
                      right: 20,   // 调整红点位置，确保它在图标的右上角
                      top: -2,     // 调整红点位置
                      height: 16,  // 红点高度
                      width: 16,   // 红点宽度
                      borderRadius: '50%',
                      backgroundColor: 'red',
                      color: '#fff',
                      fontSize: '10px', // 红点内部字体调整为适当大小
                      lineHeight: '16px',  // 使数字垂直居中
                    }}
                  >
                    {refundMsg}
                  </div>
                ) : (
                  <></>
                )}
                <img src={icons.BalanceRefund} alt="余额退款" className="icon-image-style" />
              </div>
              <div className="flex-center" style={{ position: 'relative' }} onClick={() => {
                navigate('/order-review', {
                  state: {
                    fromHome: true,
                    scrollTo: 'transactionManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                {reviewMsg > 0 ? (
                  <div
                    className="flex-center fs-14"
                    style={{
                      position: 'absolute',
                      right: 20,   // 调整红点位置，确保它在图标的右上角
                      top: -2,     // 调整红点位置
                      height: 16,  // 红点高度
                      width: 16,   // 红点宽度
                      borderRadius: '50%',
                      backgroundColor: 'red',
                      color: '#fff',
                      fontSize: '10px', // 红点内部字体调整为适当大小
                      lineHeight: '16px',  // 使数字垂直居中
                    }}
                  >
                    {reviewMsg}
                  </div>
                ) : (
                  <></>
                )}
                <img src={icons.OrderReview} alt="订单评价" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/civilized-penalty', {
                  state: {
                    fromHome: true,
                    scrollTo: 'transactionManagement'
                  } as RouteState
                });
                window.scrollTo(0, 0);
              }}>
                <img src={icons.CivilizedWash} alt="文明洗车" className="icon-image-style" />
              </div>
            </Grid>
          </Card>
        )
      }

      {
        isAdmin === 1 && (
          <Card title="店铺管理" className="mt-16 no-divider custom-card" headerStyle={{ paddingLeft: 20 }}>
            <Grid columns={4} gap={16}>
              <div ref={registerCardRef('shopManagement')} style={{ position: 'relative' }} className="flex-center" onClick={() => {
                navigate('/shop-list', {
                  state: {
                    fromHome: true,
                    scrollTo: 'shopManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                {
                  deviceMsg > 0 ? (
                    <div
                      className="flex-center fs-14"
                      style={{
                        position: 'absolute',
                        right: 20,   // 调整红点位置，确保它在图标的右上角
                        top: -2,     // 调整红点位置
                        height: 16,  // 红点高度
                        width: 16,   // 红点宽度
                        borderRadius: '50%',
                        backgroundColor: 'red',
                        color: '#fff',
                        fontSize: '10px', // 红点内部字体调整为适当大小
                        lineHeight: '16px',  // 使数字垂直居中
                      }}
                    >
                      {deviceMsg}
                    </div>
                  ) : (
                    <></>
                  )
                }
                <img src={icons.StoreDeviceManagement} alt="店铺/设备管理" className="icon-big-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/free-park', {
                  state: {
                    fromHome: true,
                    scrollTo: 'shopManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.CarWashFreeStop} alt="洗车免停" className="icon-image-style" />
              </div>
              {roleType !== 3 && (
                <div className="flex-center" onClick={redirectAuthUrl}>
                  <img src={icons.MeituanAuth} alt="美团授权" className="icon-image-style" />
                </div>
              )}
              {roleType !== 3 && (
                <div className="flex-center" onClick={() => {
                  navigate('/shop-map', {
                    state: {
                      fromHome: true,
                      scrollTo: 'shopManagement'
                    } as RouteState
                  });
                  // 添加这行
                  window.scrollTo(0, 0);
                }}>
                  <img src={icons.StoreMapping} alt="店铺映射" className="icon-image-style" />
                </div>
              )}
            </Grid>
          </Card>
        )
      }

      {
        isAdmin === 1 && (
          <Card title="用户管理" className="mt-16 no-divider custom-card" headerStyle={{ paddingLeft: 20 }}>
            <Grid columns={4} gap={16}>
              <div ref={registerCardRef('userManagement')} className="flex-center" onClick={() => {
                navigate('/users', {
                  state: {
                    fromHome: true,
                    scrollTo: 'userManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.UserManagement} alt="用户管理" className="icon-image-style" />
              </div>
              <div ref={registerCardRef('userManagement')} style={{ textAlign: 'center' }} onClick={() => {
                navigate('/blacklist#card-userManage', {
                  state: {
                    fromHome: true,
                    scrollTo: 'userManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.Blacklist} alt="黑名单" className="icon-image-style" />
              </div>
              <div ref={registerCardRef('userManagement')} className="flex-center" onClick={() => {
                navigate('/admin-setting', {
                  state: {
                    fromHome: true,
                    scrollTo: 'userManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.Settings} alt="设置" className="icon-image-style" />
              </div>
            </Grid>
          </Card>
        )
      }

      {
        isAdmin === 1 && (
          <Card title="加盟管理" className="mt-16 no-divider custom-card" headerStyle={{ paddingLeft: 20 }}>
            <Grid columns={4} gap={16}>
              <div ref={registerCardRef('joinManagement')} className="flex-center" onClick={() => {
                navigate('/operation', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }} >
                <img src={icons.OperationReconciliation} alt="运营对账" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/material', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }} >
                <img src={icons.MaterialReconciliation} alt="物料对账" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/hosting', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }} >
                <img src={icons.CustodySettings} alt="托管设置" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/map-shop', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.LocationManagement} alt="选址管理" className="icon-image-style" />
              </div>
              {roleType !== 3 && (
                <div className="flex-center" onClick={() => {
                  navigate('/admin-auth', {
                    state: {
                      fromHome: true,
                      scrollTo: 'joinManagement'
                    } as RouteState
                  });
                  // 添加这行
                  window.scrollTo(0, 0);
                }}>
                  <img src={icons.AccountPermission} alt="账号与权限" className="icon-image-style" />
                </div>
              )}
              <div className="flex-center" onClick={() => {
                navigate('/machine-customer', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                window.scrollTo(0, 0);
              }}>
                <img src={icons.MachineCustomer} alt="洗车机客户" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/join-apply', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                window.scrollTo(0, 0);
              }}>
                <img src={icons.JoinApply} alt="意向加盟商管理" className="icon-image-style" />
              </div>
            </Grid>
          </Card>
        )
      }

      {/* 加盟商 */}
      {
        roleType === 2 && (
          <Card title="对账结算" className="mt-16 no-divider custom-card" headerStyle={{ paddingLeft: 20 }}>
            <Grid columns={4} gap={16}>
              <div ref={registerCardRef('joinManagement')} className="flex-center" onClick={() => {
                navigate('/profit', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }} >
                <img src={icons.storeRevenue} alt="门店营收" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/operation', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }} >
                <img src={icons.OperationReconciliation} alt="运营对账" className="icon-image-style" />
              </div>
              <div className="flex-center" onClick={() => {
                navigate('/material', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }
              } >
                <img src={icons.MaterialReconciliation} alt="物料成本" className="icon-image-style" />
              </div>
            </Grid>
          </Card>
        )
      }

      {/* 加盟商 */}
      {
        roleType === 2 && (
          <Card title="开店支持" className="mt-16 no-divider custom-card" headerStyle={{ paddingLeft: 20 }}>
            <Grid columns={4} gap={16}>
              {isLocation === 1 && (
                <div ref={registerCardRef('joinManagement')} className="flex-center" onClick={() => {
                  navigate('/map-shop-map', {
                    state: {
                      fromHome: true,
                      scrollTo: 'joinManagement'
                    } as RouteState
                  });
                  // 添加这行
                  window.scrollTo(0, 0);
                }}>
                  <img src={icons.FindStore} alt="找店铺" className="icon-image-style" />
                </div>
              )}
              <div className="flex-center" onClick={() => {
                navigate('/admin-setting', {
                  state: {
                    fromHome: true,
                    scrollTo: 'joinManagement'
                  } as RouteState
                });
                // 添加这行
                window.scrollTo(0, 0);
              }}>
                <img src={icons.Settings} alt="设置" className="icon-image-style" />
              </div>
            </Grid>
          </Card>
        )
      }
    </div >
  )
}
